import React from 'react';
import './HouseDesign.css';
import useScrollToTop from './useScrollToTop'; // Create this CSS file
import ReusableLanding from './ReusableLanding';
import image2 from '../img/interior.jpg';
import DesignGallery from './PreGallery';
import GetQuoteForm from  './GetQuoteForm'
import FAQ from './FAQ';
import serviceFAQData from './serviceFAQData';
import { FaMoneyBillWave, FaClock, FaCheckCircle, FaPalette, FaHome, FaTools, FaLightbulb } from 'react-icons/fa'; // Import more icons


const ReadyHouseDesigns = () => {
    useScrollToTop();
    const myDesigns = [
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      {
        title: 'Modern Villa Design',
        description: 'A contemporary villa with spacious interiors...',
        layout: '50 X 80 sqft',
        builtArea: '4000 sqft',
        image: './villa1.jpg',
      },
      {
        title: 'Cozy Family Home',
        description: 'A comfortable family home with a garden...',
        layout: '35 X 60 sqft',
        builtArea: '2100 sqft',
        image: './home1.jpg',
      },
      // ... more design objects ...
    ];
  return (
    <>
     <ReusableLanding
      imageUrl={image2}
      title="Ready House Designs"
      description="Explore our collection of pre-designed house plans, crafted by experienced architects and designers. These ready-to-build designs offer a perfect blend of style, functionality, and affordability."
    />
    <div className="house-design-page">
    <section className="benefits-section"> {/* Using the existing benefits-section for consistent styling */}
            <h2>Benefits of Ready House Designs</h2>
            <p className="benefits-intro">Discover the advantages of choosing our pre-designed house plans, offering a streamlined and efficient path to building your dream home.</p>
            <ul className="benefits-list">
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaMoneyBillWave />
                    </div>
                    <h3>Cost-Effective</h3>
                    <p>Eliminate significant upfront expenses associated with custom architectural design. Our ready-made plans save you money on design fees and the time involved in the initial conceptualization and drafting stages.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaClock />
                    </div>
                    <h3>Quick Start</h3>
                    <p>Skip the lengthy design process and begin construction almost immediately. Our pre-approved and fully documented plans are ready to go, significantly reducing the timeline from concept to groundbreaking.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaCheckCircle />
                    </div>
                    <h3>Proven and Refined Designs</h3>
                    <p>Benefit from house designs that have been thoughtfully developed, tested, and often built before. This means you're investing in plans with practical layouts and construction considerations already addressed, minimizing potential issues.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaPalette />
                    </div>
                    <h3>Wide Variety of Styles</h3>
                    <p>Explore an extensive collection of architectural styles, including modern minimalist, classic traditional, charming contemporary, rustic farmhouse, and more. Find a design that perfectly matches your aesthetic preferences and lifestyle.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaHome />
                    </div>
                    <h3>Functional and Livable Layouts</h3>
                    <p>Our ready house designs prioritize functionality and comfortable living. They are created with careful consideration of room flow, natural light, storage solutions, and overall usability to enhance your daily life.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaTools />
                    </div>
                    <h3>Detailed Construction Documents</h3>
                    <p>Receive comprehensive construction document sets that include detailed floor plans, elevations, sections, and often material specifications. These documents are essential for accurate bidding, obtaining permits, and guiding your construction team.</p>
                </li>
                <li className="card"> {/* Applying card styling for visual consistency */}
                    <div className="benefit-icon">
                        <FaLightbulb />
                    </div>
                    <h3>Reduced Decision Fatigue</h3>
                    <p>Choosing a ready house design can simplify the often overwhelming number of decisions involved in a custom design process. You can focus on personalizing the interior finishes and landscaping rather than the fundamental layout.</p>
                </li>
                {/* You can add even more benefits here */}
            </ul>
        </section>
      <h2>Our Featured Designs</h2>
      <DesignGallery designs={myDesigns} />

      <section>
        <h2>How to Purchase</h2>
        <p>
          Browse our catalog, select your preferred design, and contact us to purchase the plans. We offer customization options to tailor the design to your specific needs.
        </p>
      </section>
      <GetQuoteForm/>
      <FAQ faqData= {serviceFAQData}/>
    </div>
    </>
  );
};

export default ReadyHouseDesigns;